import { computed } from 'mobx'
import { getRoomStateResets } from '../../firestore/RoomStateReset'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { RoomStateReset } from '../../models/RoomStateReset'
import type { StaticModelCollection } from '../../types'
import { guardOn, guardOnLoaded } from '../../util/guardOn'
import { Cubit } from '../core'

export class RoomStateResetsController extends Cubit {
  repository: FirebaseRepository
  roomId: string

  _roomStateResets: StaticModelCollection<RoomStateReset>

  constructor(repository: FirebaseRepository, { roomId }: { roomId: string }) {
    super()
    this.repository = repository
    this.roomId = roomId
    this._roomStateResets = RoomStateReset.emptyCollection(repository)
  }

  initialize(): void {
    this.addStream(
      getRoomStateResets(this.repository, { roomId: this.roomId }),
      (resets) => {
        this._roomStateResets.replaceModels(resets)
      }
    )
  }

  @computed
  get roomStateResets() {
    return guardOnLoaded(this._roomStateResets, (r) => r)
  }

  @computed
  get roomStateResetsWithUserInfo() {
    const resetsData = this.roomStateResets
    if (resetsData.isLoading) return resetsData

    const resets = resetsData.value

    // Sort resets by startedAt descending (most recent first)
    const sortedResets = [...resets].sort((a, b) => {
      const aTime = a.data.startedAt?.getTime() ?? 0
      const bTime = b.data.startedAt?.getTime() ?? 0
      return bTime - aTime
    })

    const sorted = sortedResets.map((reset) => {
      const user = this.repository.userStore.getUser(reset.data.userId)
      return {
        reset,
        user,
      }
    })

    return guardOn(true, () => sorted)
  }
}
